import { Typography } from '@mui/material';
import Lottie from 'lottie-react';
import { useBoolean } from 'usehooks-ts';

import AclosetOrderModal from '@/app/AclosetOrderModal';
import useAclosetOrderCountData from '@/app/useAclosetOrderCountData';

import '../animation.css';
import lottie from './lottie.json';

/**
 * 세컨솔드 주문 / 반품 미처리 알림
 * TODO: 세컨솔드_미처리_개수가 변경될 때마다, 리렌더링 되도록 변경해야 함.
 */
export function 세컨솔드_미처리_알림() {
  const { totalCount: 세컨솔드_미처리_개수 } = useAclosetOrderCountData();

  if (세컨솔드_미처리_개수 === 0) {
    return;
  }

  return <LottieComponent />;
}

function LottieComponent() {
  const { totalCount: 세컨솔드_미처리_개수 } = useAclosetOrderCountData();
  const { value: isOpen, setTrue: onOpen, setFalse: onClose } = useBoolean();

  return (
    <>
      <div style={{ position: 'relative', top: 3, cursor: 'pointer' }} onClick={onOpen}>
        <Lottie animationData={lottie} loop={false} />
        <Typography
          className="fade-in-box"
          variant="Subtitle_Looko"
          color="#536DFE"
          position={'absolute'}
          style={{
            top: 8,
            left: 40,
          }}
        >
          세컨솔드 미처리 주문/반품 {세컨솔드_미처리_개수}건
        </Typography>
      </div>

      {isOpen && (
        <AclosetOrderModal
          세컨솔드_미처리알람클릭_모달상태={isOpen}
          세컨솔드_미처리알람클릭_모달닫기={onClose}
          로컬스토리지에_저장하는가={false}
        />
      )}
    </>
  );
}
